// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__31Udg","icon":"SortAdornment_icon__QB6NO","up":"SortAdornment_up__1AShA","down":"SortAdornment_down__3lP6z","active":"SortAdornment_active__1QzcD"};